var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allowActivity)?_c('div',[(!_vm.loggedIn)?_c('login-in-to-join-in',{class:_vm.loginClass,attrs:{"message":_vm.message}}):(!_vm.completedLogin)?_c('add-display-name',{class:_vm.loginClass}):_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }